import React from 'react';
import { Link } from 'react-router-dom'
import SubLayout from '../../components/Layout/SubLayout'
import strings from "../../components/Language";
import "./wallet.scss"
import _ from 'lodash';

import NoDataFound from './../../assets/images/icons/no_data_found.svg';

import walletdeposit from './../../assets/images/icons/wallet-deposit.webp';
import walletwithdraw from './../../assets/images/icons/wallet-withdraw.webp';
import wallettransfer from './../../assets/images/icons/wallet-transfer.webp';
import walletcoin from './../../assets/images/icons/wallet-coin.svg';
import convert from './../../assets/images/icons/convert.png';
import notifications from './../../assets/images/menu/notification.png';
import ArrowForword from './../../assets/images/icons/arrow_forword.svg';

import { Button } from 'antd';
import { toast } from 'react-toastify';
import axios from 'axios';
import { api } from '../../components/config/api.js';
import { getToken, storeUserData, getUserData } from '../../components/Util';

import ListItem from '@mui/material/ListItem';
import LoaderContext from '../../components/Loader/LoaderContext.js';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
class WalletScreen extends React.Component {

	static contextType = LoaderContext;
	constructor(props) {
		super(props);
		this.state = {
			access_token: "",
			data: [],
			nextPageLink: "",
			prevPageLink: "",
			balance: 0,
			user_data: {},
			active_tab: "usdt",
			startDate: null,
			endDate: null,

		}
	}

	async componentDidMount() {
		var token = await getToken();
		if (token) {
			await storeUserData(token);
			this.setState({ access_token: token });
			setTimeout(() => {
				var user_data = getUserData();
				this.setState({ user_data: (user_data && user_data.data) ? user_data.data : {} });
				this.getData(api.usdt_history);
			});
		}
	}

	getData(API) {
		if (!API) {
			toast.error(strings.URI_not_found);
			return false;
		}
		var self = this;
		const { setLoading } = this.context;
		setLoading(true);
		axios({
			method: 'GET',
			url: API,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {

			if (ress.data.data && ress.data.data.length > 0) {
				self.setState({
					data: ress.data.data,
					nextPageLink: ress.data.links.next,
					prevPageLink: ress.data.links.prev,
					balance: ress.data.available_usdt
				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			setLoading(false);
		});
	};

	getNextData(API) {
		if (!API) {
			toast.error(strings.URI_not_found);
			return false;
		}
		var API_URL = API;
		if (this.state.startDate && this.state.endDate) {
			API_URL = API + "&start_date=" + (this.state.startDate ? moment(this.state.startDate).format("YYYY-MM-DD") : "") + "&end_date=" + (this.state.endDate ? moment(this.state.endDate).format("YYYY-MM-DD") : "");
		}
		var self = this;
		self.setState({
			nextPageLink: "",
			prevPageLink: "",
		});
		const { setLoading } = this.context;
		setLoading(true);
		axios({
			method: 'GET',
			url: API_URL,
			headers: {
				'Authorization': 'Bearer ' + self.state.access_token,
				'Content-Type': 'application/json',
				'Accept-Language': strings.getLanguage()
			}
		}).then(function (ress) {

			if (ress.data.data && ress.data.data.length > 0) {
				self.setState({
					data: [...self.state.data, ...ress.data.data],
					nextPageLink: ress.data.links.next,
					prevPageLink: ress.data.links.prev,
				});
			} else {
				if (ress.data.validation && ress.data.validation.length !== 0) {
					_.forEach(ress.data.validation, function (value) {
						if (value[0]) {
							toast.error(value[0]);
						}
					});
				} else {
					toast.error(ress.data.message);
				}
			}
			setLoading(false);
		}).catch(function (e) {
			toast.error(e.message);
			setLoading(false);
		});
	};

	handleChange = (dates) => {
		const [start, end] = dates;
		this.setState({ startDate: start, endDate: end });

		if (this.props.onChange) {
			this.props.onChange({ startDate: start, endDate: end });
		}
		setTimeout(() => {
			if (start && end) {
				const startDate = moment(start).format("YYYY-MM-DD");
				const endDate = moment(end).format("YYYY-MM-DD");
				this.getData(`${api.usdt_history}?start_date=${startDate}&end_date=${endDate}`);
			}
		});
	};


	render() {
		const { startDate, endDate } = this.state;

		return (
			<SubLayout data={{ "title": strings.wallet }}>
				<div className="offset-md-4 col-md-4" style={{ paddingInline: 5 }}>
					<div style={{ marginTop: 10 }}>
						<div className='flex-center list_back_active' style={{ justifyContent: "space-between", padding: 10, borderRadius: 10 }}>
							<div className='flex-center' style={{ flexDirection: "row" }}>
								<img src={walletcoin} alt="Api1" width={60} height={60}></img>
								<div style={{ marginLeft: 10 }}>
									<div style={{}}>
										<span style={{ fontSize: 12, color: "#000", borderWidth: "bold" }}>{strings.usdt_balance}</span>
									</div>
									<div style={{}}>
										<span style={{ fontSize: 18 }}>{this.state.balance.toFixed(8)}</span>
									</div>
									<div style={{}}>
										<span style={{ fontSize: 14 }}>= {this.state.balance.toFixed(8)} {strings.usdt}</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div style={{ marginTop: 0 }}>
						<div className='flex-center' style={{
							justifyContent: "center", padding: 10, borderRadius: 5, marginTop: 10
						}}>
							<Link to={"/deposit"} className='text-center' style={{ marginInline: 15 }}>
								<img src={walletdeposit} alt="CTS Bot" height={60}></img>
								<div style={{}}>
									<span style={{ fontSize: 16 }}>{strings.deposit}</span>
								</div>
							</Link>
							<Link to={"/transfer"} className='text-center' style={{ flexDirection: "row", marginInline: 15 }}>
								<img src={wallettransfer} alt="CTS Bot" height={60}></img>
								<div style={{}}>
									<span style={{ fontSize: 16 }}>{strings.transfer}</span>
								</div>
							</Link>
							<Link to={"/withdrawal"} className='text-center' style={{ flexDirection: "row", marginInline: 15 }}>
								<img src={walletwithdraw} alt="CTS Bot" height={60}></img>
								<div style={{}}>
									<span style={{ fontSize: 16 }}>{strings.withdraw}</span>
								</div>
							</Link>
						</div>
					</div>
					{(
						this.state.user_data
						&& (this.state.user_data.credit && this.state.user_data.credit.usdt >= 2 && this.state.user_data.credit.usdt < 20)
						&& (this.state.user_data.status_data && this.state.user_data.status_data.identifier == "active")
					) ?
						<>
							<div className='border_'></div>
							<div className='text-danger' style={{ padding: 10 }}>{strings.fuel_balance_is_insufficient}</div>
						</>
						:
						null
					}
					<div className='border_'></div>
					<div style={{ marginTop: 10 }}>
						<div className='flex-center' style={{
							justifyContent: "space-between", padding: 10, borderRadius: 5
						}}>
							<span style={{}}>{strings.history_record}</span>
						</div>
						<div className='api_list_back_wallet'>
							<DatePicker
								selected={startDate}
								onChange={this.handleChange}
								startDate={startDate}
								endDate={endDate}
								selectsRange
								isClearable
								className="form-control text_box datepicker-input"
								placeholderText={strings.select_a_date_range}
							/>
						</div>
					</div>
					<div style={{ marginTop: 0 }}>
						{this.state.data && this.state.data.length > 0 ?
							<>
								{
									this.state.data.map((item, i) =>
										<ListItem disablePadding key={i}>
											<Link to={{
												// pathname: `/binding/${item.id}`,
												data: item,
												params: item.id
											}} params={{ data: item }}
												style={{ marginTop: 10, display: "inline-block", width: "100%" }}>
												<div className={`api_list_back_wallet`}>
													<div style={{ padding: 10, borderRadius: 5, background: "#07051f" }}>
														<div className={`flex-center`} style={{
															justifyContent: "space-between"
														}}>
															<div className='col-7' style={{ flexDirection: "row", paddingRight: 5 }}>
																<div style={{ marginLeft: 10 }}>
																	<span style={{ fontWeight: "bold" }}>{item.amount.toFixed(8)}</span>
																</div>
															</div>
															<div className='col-5 flex-center' style={{ flexDirection: "row", fontSize: 12, justifyContent: "flex-end" }}>
																{item.created_at_ ? moment(item.created_at).format("YYYY/MM/DD HH:mm:ssA") : '-'}
															</div>
														</div>
														<div style={{ marginLeft: 10, overflowWrap: "anywhere" }}>
															<span style={{ fontWeight: "bold", fontSize: 12 }}>{item.description}</span>
														</div>
													</div>
												</div>
											</Link>
										</ListItem>
									)
								}
								{this.state.nextPageLink ?
									<div className='flex-center' style={{ justifyContent: "center" }}>
										<Button onClick={() => this.getNextData(this.state.nextPageLink)} type="primary" className='btn rounded-sm btn-m text-uppercase font-700 mt-4 mb-3 btn-full '
											style={{ fontSize: 14, paddingBlock: 10, background: '#446CE3', color: "#FFF" }}>
											{strings.Load_More}
										</Button>
									</div>
									: null}
							</>
							: <div className='text-center' style={{ padding: 20, borderRadius: 5 }}>
								<img src={NoDataFound} alt="CTS Bot"></img>
							</div>}
					</div>
				</div>
			</SubLayout >
		);
	}
}

export default WalletScreen;
